import { FormlyFieldConfig } from '@ngx-formly/core';
import { takeUntil } from 'rxjs/operators';
import { VehicleToGridInfoService } from '@intellio/shared/services';
import { getChildObject } from './form-data.utility';
import type { FormlyHookFn } from './formly-hook-fn.type';

export const prefillVehicleToGridDetailsHook = (
  destroyed$,
  vehicleToGridInfoService: VehicleToGridInfoService
): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    field.formControl?.valueChanges.pipe(takeUntil(destroyed$)).subscribe((modelNumber) => {
      if (!modelNumber) {
        return;
      }

      const parent = field.parent;
      const manufacturerField = getChildObject(parent, 'evseManufacturer');
      const manufacturer = parent.parent.formControl.get(manufacturerField.key).value;

      vehicleToGridInfoService.getVehicleToGridInfo().subscribe((response) => {
        const record = response.data.find(
          (item) => item.manufacturer === manufacturer && item.modelNumber === modelNumber
        );

        if (!record) {
          return;
        }

        const form = parent.formControl;
        form.get(getChildObject(parent, 'evseRatedPowerKw').key)
          ?.setValue(record.maximumDischargePowerKw);
        form.get(getChildObject(parent, 'acNominalVoltage').key)
          ?.setValue(record.nominalVoltage);
        form.get(getChildObject(parent, 'ul1741Sa').key)
          ?.setValue(record.uL1741SACertified);
        form.get(getChildObject(parent, 'ul1741Sb').key)
          ?.setValue(record.uL1741SBCertified);
        form.get(getChildObject(parent, 'ul1741Sc').key)?.setValue(record.uL1741SCCertified);
      });
    });
  };
};
